import React from 'react'
import Chart from "./Chart"
import {newRecord,getCurrentprice, addToRecord,fetchData} from "../api/data"
const Donut = () => {
    return (
        <Chart />
    )
}

export default Donut
